<template>
    <v-card :loading="form.busy || loading" mx-4 min-height="500">
        <template slot="progress">
            <v-overlay absolute class="d-flex flex-column text-center">
                <div>
                    <v-progress-circular size="250" width="10" color="primary" indeterminate>
                        <span>In curs de incarcare...</span>
                    </v-progress-circular>
                </div>
            </v-overlay>
        </template>
        <v-tabs
            v-model="tab"
            background-color="primary"
            dark
        >
            <v-tab key="company">
                Date companie
            </v-tab>
            <v-tab key="database">
                Administrare Baza de Date
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item key="company">
                <v-card class="px-4 py-4" flat>
                    <v-row>
                        <v-col cols="6">
                            <v-text-field
                                v-model="form.name"
                                v-validate="'required'"
                                :error-messages="errorMessages('name')"
                                :class="{ 'error--text': hasErrors('name') }"
                                class="primary--text"
                                name="name"
                                label="Denumire"
                                data-vv-name="name"
                                counter="255"
                            />
                        </v-col>
                        <v-col cols="6">
                            <v-row>
                                <v-col cols="4">
                                    <v-text-field
                                        v-model="form.data.company_vat"
                                        v-validate="'required'"
                                        :error-messages="errorMessages('company_vat')"
                                        :class="{ 'error--text': hasErrors('company_vat') }"
                                        class="primary--text"
                                        name="company_vat"
                                        label="CUI (Cod Unic de Identificare)"
                                        data-vv-name="company_vat"
                                        counter="255"
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <v-text-field
                                        v-model="form.data.company_regcom"
                                        v-validate="'required'"
                                        :error-messages="errorMessages('company_regcom')"
                                        :class="{ 'error--text': hasErrors('company_regcom') }"
                                        class="primary--text"
                                        name="company_regcom"
                                        label="Numarul Registrul Comertului"
                                        data-vv-name="company_regcom"
                                        counter="255"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3">
                            <v-text-field
                                v-model="form.data.company_county"
                                v-validate="'required'"
                                :error-messages="errorMessages('company_county')"
                                :class="{ 'error--text': hasErrors('company_county') }"
                                class="primary--text"
                                name="company_county"
                                label="Judet"
                                data-vv-name="company_county"
                                counter="255"
                            />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field
                                v-model="form.data.company_city"
                                v-validate="'required'"
                                :error-messages="errorMessages('company_city')"
                                :class="{ 'error--text': hasErrors('company_city') }"
                                class="primary--text"
                                name="company_city"
                                label="Localitate"
                                data-vv-name="company_city"
                                counter="255"
                            />
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                v-model="form.data.company_address"
                                v-validate="'required'"
                                :error-messages="errorMessages('company_address')"
                                :class="{ 'error--text': hasErrors('company_address') }"
                                class="primary--text"
                                name="company_address"
                                label="Adresa"
                                data-vv-name="company_address"
                                counter="255"
                            />
                        </v-col>
                        <v-col cols="2">
                            <v-text-field
                                v-model="form.data.company_address_no"
                                v-validate="'required'"
                                :error-messages="errorMessages('company_address_no')"
                                :class="{ 'error--text': hasErrors('company_address_no') }"
                                class="primary--text"
                                name="company_address_no"
                                label="Numar/Apartament"
                                data-vv-name="company_address_no"
                                counter="255"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3">
                            <v-textarea
                                v-model="form.data.company_bank"
                                v-validate="'required'"
                                :error-messages="errorMessages('company_bank')"
                                :class="{ 'error--text': hasErrors('company_bank') }"
                                class="primary--text"
                                name="company_bank"
                                label="Conturi bancare"
                                data-vv-name="company_bank"
                            />
                        </v-col>
                        <v-col cols="3">
                            <v-textarea
                                v-model="form.data.company_phone"
                                v-validate="'required'"
                                :error-messages="errorMessages('company_phone')"
                                :class="{ 'error--text': hasErrors('company_phone') }"
                                class="primary--text"
                                name="company_phone"
                                label="Numere de telefon"
                                data-vv-name="company_phone"
                            />
                        </v-col>
                        <v-col cols="3">
                            <v-textarea
                                v-model="form.data.company_email"
                                v-validate="'required'"
                                :error-messages="errorMessages('company_email')"
                                :class="{ 'error--text': hasErrors('company_email') }"
                                class="primary--text"
                                name="company_email"
                                label="Adrese de e-mail"
                                data-vv-name="company_email"
                            />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field
                                v-model="form.data.company_website"
                                :error-messages="errorMessages('company_website')"
                                :class="{ 'error--text': hasErrors('company_website') }"
                                class="primary--text"
                                name="company_website"
                                label="Adresa web"
                                data-vv-name="company_website"
                                counter="255"
                            />
                            <v-text-field
                                v-model="form.data.administrator_name"
                                :error-messages="errorMessages('administrator_name')"
                                :class="{ 'error--text': hasErrors('administrator_name') }"
                                class="primary--text"
                                name="administrator_name"
                                label="Nume administrator"
                                data-vv-name="administrator_name"
                                counter="255"
                            />
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-subheader>Setari documente</v-subheader>
                    <v-row>
                        <v-col cols="6">
                            <v-text-field
                                v-model="form.data.company_invoice_due"
                                :error-messages="errorMessages('data.company_invoice_due')"
                                :class="{ 'error--text': hasErrors('data.company_invoice_due') }"
                                class="primary--text"
                                name="data.company_invoice_due"
                                label="Scadenta facturi"
                                data-vv-name="data.company_invoice_due"
                                type="number"
                            />
                            <v-text-field
                                v-model="form.data.company_invoice_prefix"
                                :error-messages="errorMessages('data.company_invoice_prefix')"
                                :class="{ 'error--text': hasErrors('data.company_invoice_prefix') }"
                                class="primary--text"
                                name="data.company_invoice_prefix"
                                label="Serie factura"
                                data-vv-name="data.company_invoice_prefix"
                            />
                            <v-text-field
                                v-model="form.data.company_workestimate_prefix"
                                :error-messages="errorMessages('data.company_workestimate_prefix')"
                                :class="{ 'error--text': hasErrors('data.company_workestimate_prefix') }"
                                class="primary--text"
                                name="data.company_workestimate_prefix"
                                label="Serie deviz de lucrari"
                                data-vv-name="data.company_workestimate_prefix"
                            />
                            <v-text-field
                                v-model="form.data.company_transport_prefix"
                                :error-messages="errorMessages('data.company_transport_prefix')"
                                :class="{ 'error--text': hasErrors('data.company_invoice_prefix') }"
                                class="primary--text"
                                name="data.company_transport_prefix"
                                label="Serie comanda transport"
                                data-vv-name="data.company_transport_prefix"
                            />
                            <v-text-field
                                v-model="form.data.construction_estimate_prefix"
                                :error-messages="errorMessages('data.construction_estimate_prefix')"
                                :class="{ 'error--text': hasErrors('data.construction_estimate_prefix') }"
                                class="primary--text"
                                name="data.construction_estimate_prefix"
                                label="Serie deviz de constructii"
                                data-vv-name="data.construction_estimate_prefix"
                            />
                        </v-col>
                        <v-col cols="6">
                            <v-textarea
                                v-model="form.data.company_invoice_remarks"
                                :error-messages="errorMessages('data.company_invoice_remarks')"
                                :class="{ 'error--text': hasErrors('data.company_invoice_remarks') }"
                                class="primary--text"
                                name="data.company_invoice_remarks"
                                label="Observatii factura"
                                data-vv-name="data.company_invoice_remarks"
                            />
                        </v-col>
                    </v-row>
                    <v-btn
                        :loading="form.busy"
                        :disabled="errors.any() || form.busy"
                        block
                        color="success"
                        @click="submit()"
                    >
                        Salveaza
                        <v-icon right>
                            save
                        </v-icon>
                    </v-btn>
                </v-card>
            </v-tab-item>

            <v-tab-item key="database">
                <v-card class="px-4 py-4" flat>
                    <v-row>
                        <v-col cols="12">
                            <h3>Inlocuire cod furnizor</h3>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                v-model="database.supplier.old_code"
                                v-validate="'required'"
                                :error-messages="errorMessages('old_code')"
                                :class="{ 'error--text': hasErrors('old_code') }"
                                class="primary--text"
                                name="old_code"
                                label="Cod vechi"
                                data-vv-name="old_code"
                                counter="255"
                            />
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                v-model="database.supplier.new_code"
                                v-validate="'required'"
                                :error-messages="errorMessages('new_code')"
                                :class="{ 'error--text': hasErrors('new_code') }"
                                class="primary--text"
                                name="new_code"
                                label="Cod nou"
                                data-vv-name="new_code"
                                counter="255"
                            />
                        </v-col>
                        <v-col cols="4">
                            <v-btn
                                :loading="database.loading"
                                :disabled="database.loading"
                                block
                                color="success"
                                @click="databaseUpdateSuppliers"
                            >
                                Actualizare Furnizori
                                <v-icon right>
                                    save
                                </v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <h3>Inlocuire cod client</h3>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                v-model="database.customer.old_code"
                                v-validate="'required'"
                                :error-messages="errorMessages('old_code')"
                                :class="{ 'error--text': hasErrors('old_code') }"
                                class="primary--text"
                                name="old_code"
                                label="Cod vechi"
                                data-vv-name="old_code"
                                counter="255"
                            />
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                v-model="database.customer.new_code"
                                v-validate="'required'"
                                :error-messages="errorMessages('new_code')"
                                :class="{ 'error--text': hasErrors('new_code') }"
                                class="primary--text"
                                name="new_code"
                                label="Cod nou"
                                data-vv-name="new_code"
                                counter="255"
                            />
                        </v-col>
                        <v-col cols="4">
                            <v-btn
                                :loading="database.loading"
                                :disabled="database.loading"
                                block
                                color="success"
                                @click="databaseUpdateCustomers"
                            >
                                Actualizare Clienti
                                <v-icon right>
                                    save
                                </v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-simple-checkbox v-model="database.dryRun"/> Simulare operatiune
                        </v-col>
                    </v-row>
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </v-card>
</template>

<script>
    import validationError from "Mixins/validation-error";
    import {Form} from "vform";

    export default {
        mixins: [validationError],
        props: {
            id: {
                type: [Number, String],
                required: false
            }
        },
        data: () => ({
            tab: 'general',
            loading: false,
            /* Always Declare Your Form Object */
            form: new Form({
                id: null,
                name: null,
                data: {
                    company_name: null,
                    company_vat: null,
                    company_regcom: null,
                    company_authorization: null,
                    company_county: null,
                    company_city: null,
                    company_address: null,
                    company_address_no: null,
                    company_bank: null,
                    company_phone: null,
                    company_email: null,
                    company_website: null,
                    company_invoice_due: null,
                    company_invoice_prefix: null,
                    company_workestimate_prefix: null,
                    company_invoice_remarks: null,
                    administrator_name: null
                }
            }),
            database: {
                loading: false,
                dryRun: true,
                supplier: {
                    old_code: null,
                    new_code: null
                },
                customer: {
                    old_code: null,
                    new_code: null
                }
            }
        }),
        watch: {
            'form.name': {
                handler(val) {
                    this.form.data.company_name = val
                }
            }
        },
        async mounted() {
            if(this.id) {
                await this.loadResources()
            }
        },
        methods: {
            async loadResources() {
                let self = this;
                this.loading = true;

                let { data } = await this.$db.Workstation.find(this.id)
                self.form = new Form(Object.assign(this.form, data))
                setTimeout(() => this.loading = false, 1000)
            },
            async submit() {
                let self = this;
                this.$validator.validateAll().then(result => {
                    if (result) {
                        // eslint-disable-next-line
                        self.createOrUpdate();
                    } else {
                        this.showError()
                    }
                });
            },
            async createOrUpdate() {
                let self = this;
                self.form.busy = true;

                var model = new this.$db.Workstation(self.form);
                if (this.id) {
                    model.id = this.id
                }

                model.save()
                    .then(response => {
                        self.$validator.reset();
                        this.showSuccess();
                        self.$nextTick(() => self.$router.push({name: "admin-configuration-index"}));
                    })
                    .catch(errors => {
                        self.form.errors.set(this.form.extractErrors(errors.response))
                        this.showError()
                    }).finally(() => {
                        self.form.busy = false;
                    });
            },
            async databaseUpdateSuppliers() {
                this.database.loading = true
                await axios.post(route('workstations.update-suppliers', {
                    workstation: this.form.id
                }), {
                    dryRun: this.database.dryRun,
                    oldId: this.database.supplier.old_code,
                    newId: this.database.supplier.new_code
                }).then(async (response) => {
                    await this.showSuccess(response?.data?.message)
                }).catch(async (err) => {
                    await this.showError(err?.response?.data?.message)
                }).finally(() => {
                    this.database.loading = false
                })
            },
            async databaseUpdateCustomers() {
                this.database.loading = true
                await axios.post(route('workstations.update-customers', {
                    workstation: this.form.id
                }), {
                    dryRun: this.database.dryRun,
                    oldId: this.database.customer.old_code,
                    newId: this.database.customer.new_code
                }).then(async (response) => {
                    await this.showSuccess(response?.data?.message)
                }).catch(async (err) => {
                    await this.showError(err?.response?.data?.message)
                }).finally(() => {
                    this.database.loading = false
                })
            }
        }
    };
</script>
